module.exports = __webpack_public_path__ + "static/media/noWorkflows.475f5c08.svg";